// Une demande de Suspension / Remobilisation devient une à trois entrées du
// parcours : la demande, le retrait de l'ordre du jour (effectué ou non) et la
// décision du Directeur. Même mécanique que les synchros France Travail : les
// demandes sont lues par l'API et fusionnées côté BOA (mergeAndSort), sans
// passer par la collection d'événements.
const evenement = (demande, etape, date) => ({
  kind: "SUSPENSION_REMOBILISATION",
  id: `suspension-remobilisation-${demande.id}-${etape}`,
  date,
  etape,
  demande,
});

export function mapDemandeSuspensionRemobilisationToEvents(demande) {
  const events = [evenement(demande, "demande", demande.requestedAt)];

  if (demande.epRegistrationWithdrawal) {
    // Depuis le 15/09/2026 le retrait a lieu dès l'enregistrement et porte sa
    // date ; les demandes du circuit précédent l'ont eu à la décision.
    events.push(evenement(demande, "retrait", demande.epRegistrationWithdrawal.at ?? demande.directorDecision?.at ?? demande.requestedAt));
  }

  if (demande.directorDecision) {
    events.push(evenement(demande, "decision", demande.directorDecision.at));
  }

  return events;
}
